module.exports = __webpack_public_path__ + "img/Pot3.296b0178.svg";